import { PurchaseRelatedModel } from 'api-hooks/sale/common';
import { NavigationRoutes } from 'common/constants';
import stylesColors from 'common/styles/styles.colors';
import { string2money } from 'common/utils/string';
import Separator from 'components/common/separator';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import useDate from 'hooks/use-date';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  data: PurchaseRelatedModel[];
  navigation:
    | 'ActivityPurchasesView'
    | 'FlightPurchasesView'
    | 'HotelPurchasesView'
    | 'CruisePurchasesView'
    | 'DocumentPurchasesView';
}

export default function PurchaseRelatedTable(props: Props) {
  const { t } = useTranslation();
  const { data, navigation } = props;

  const formatDate = useDate();

  const columns = React.useMemo<IColumn<PurchaseRelatedModel>[]>(
    () => [
      {
        header: t('common:purchase_order'),
        accessorKey: 'number',
        minSize: 250,
      },
      {
        header: t('common:created_at'),
        accessorKey: 'createdAt',
        minSize: 250,
        cell: ({ getValue }) => <>{formatDate(getValue() as Date)}</>,
      },
      {
        header: t('common:total'),
        accessorKey: 'total',
        minSize: 250,
        cell: ({ getValue }) => `Rp ${string2money(getValue() as number)}`,
      },
    ],
    [formatDate, t],
  );

  return (
    <>
      <TableComponent
        columns={columns}
        data={data || []}
        headerColor={stylesColors.bg1}
        rowLink={(row) => {
          return {
            pathname: NavigationRoutes[`${navigation}`],
            query: {
              id: row.original.id,
            },
          };
        }}
        showBorder
      />
      <Separator gap={16} />
    </>
  );
}
